import { useCallback } from "react";
import { ButtonDS, SidePanelDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useAppSelector } from "../../../../../redux/hooks";
import { selectElectricVehicles } from "../../electricVehiclesSlice";
import { SidePanelHeader } from "./sidePanelHeader";
import { ElectricVehicleDetails } from "./electricVehicleDetails";
import "../../../../../i18n/i18n";

export const ElectricVehicleSidePanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const firstPath = location.pathname.split("/")[1];
  const electricVehicles = useAppSelector(selectElectricVehicles);

  const electricVehicle =
    electricVehicles.find((v) => v.uuid === params.id) ?? null;

  const onSidePanelClosed = useCallback(() => {
    navigate(`/${firstPath}/electric_charging/electric_vehicles`);
  }, [firstPath, navigate]);

  const onSeeChargesClicked = useCallback(() => {
    if (!electricVehicle) return;
    navigate(
      `/${firstPath}/electric_charging/charging_tracking?filterRegistrationNumber=${electricVehicle.registrationNumber}`,
    );
  }, [electricVehicle, firstPath, navigate]);

  if (!electricVehicle) {
    return;
  }

  return (
    <SidePanelDS.SidePanel
      visible={!!electricVehicle}
      onClose={onSidePanelClosed}
      absoluteSection={
        <ButtonDS
          text={t("electric_vehicles.sidePanel.charges")}
          format="fill"
          buttonType="secondary"
          onClick={onSeeChargesClicked}
        />
      }
    >
      <SidePanelDS.Section
        verticalSpacing={1.5}
        horizontalSpacing={1.5}
        background={colors["colors/button/secondary/hover"]}
      >
        <SidePanelHeader electricVehicle={electricVehicle} />
      </SidePanelDS.Section>
      <SidePanelDS.Section verticalSpacing={1.5} horizontalSpacing={1.5}>
        <ElectricVehicleDetails electricVehicle={electricVehicle} />
      </SidePanelDS.Section>
    </SidePanelDS.SidePanel>
  );
};
